import { get } from '../index';

export const getBrands = () => {
  return get('/brands');
};

export const getBrandById = id => {
  return get(`/brands/${id}`);
};
